"use client"

import React, { useEffect, useRef, useState } from "react"
import Header from "@/components/Header"
import SecondaryServicesNav from "@/components/SecondaryServicesNav"
import JotformEmbed from "@/components/JotformEmbed"
import { useI18n } from '@/context/i18n'
import { usePathname } from 'next/navigation'

export default function SeccionPage() {
  const [loading, setLoading] = useState(true)
  const [formUrl, setFormUrl] = useState<string | null>(null)
  const [title, setTitle] = useState<string | null>(null)
  const pathname = usePathname()
  const iframeRef = useRef<HTMLIFrameElement>(null)

  useEffect(() => {
    const handleJotformMessage = (e: MessageEvent) => {
      if (typeof e.data === 'string') {
        const args = e.data.split(':');
        if (args.length > 0 && args.includes('setHeight') && iframeRef.current) {
          const height = args[args.indexOf('setHeight') + 1];
          if (height) {
            iframeRef.current.style.height = `${height}px`;
            iframeRef.current.style.minHeight = `${Math.max(parseInt(height), 800)}px`;
          }
        }
      }
    };
    window.addEventListener('message', handleJotformMessage);
    return () => window.removeEventListener('message', handleJotformMessage);
  }, []);

  useEffect(() => {
    // extract slug from pathname: expect /formularios/:slug
    const parts = (pathname || '').split('/').filter(Boolean)
    const slug = parts.length >= 2 ? parts[1] : parts[0]
    if (!slug) {
      setLoading(false)
      return
    }

    void (async () => {
      try {
        const res = await fetch(`/api/forms?slug=${encodeURIComponent(slug)}`)
        if (!res.ok) {
          setLoading(false)
          return
        }
        const data = await res.json()
        setTitle(data?.title ?? slug)
        setFormUrl(data?.content?.form_url ?? null)
      } catch (e) {
        // ignore
      } finally {
        setLoading(false)
      }
    })()
  }, [pathname])

  return (
    <>
      <Header />
      <SecondaryServicesNav />
      <br />
      <br />
      <div className="container mx-auto px-4 py-8">
        {title ? (
          <h1 className="title">{title}</h1>
        ) : (
          <h1 className="title">Formulario <span className="card-title">de registro</span></h1>
        )}
        {loading ? (
          <div>Cargando...</div>
        ) : (
          <JotformEmbed 
            src={formUrl ?? process.env.NEXT_PUBLIC_JOTFORM_URL} 
            title={title ?? 'Formulario de registro'} 
          />
        )}
      </div>
      <style jsx>{`
        .container {
          max-width: 1000px;
          margin: 0 auto;
          padding: 16px;
        }
        .title {
          font-size: 2rem;
          font-weight: bold;
          margin-bottom: 16px;
          text-align: center;
        }
        .card-title {
          color: #ffffffff;
          font-size: 2rem;
          font-weight: bold;
          margin-bottom: 16px;
          text-align: center;
          background: #fb0009;
          padding: 0 8px;
        }
      `}</style>
    </>
  )
}
